import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '../../features/auth/authSlice';
import { statApi } from '../../services/statApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [statApi.reducerPath]: statApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(statApi.middleware),
});

// Enables refetchOnFocus / refetchOnReconnect.
setupListeners(store.dispatch);
